export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10418.c6e3d8e9.jpg";